import React, { useCallback, useContext, useEffect, useState } from "react";
import { TostMsg } from "../../../../App";
import { GetMasterSystemAlert } from "../../../../Services/Global-Services/GlobalServices";
import LeaveHierachy from "./leavehierachy";
import { leaveDashboardBalenceCount } from "../leaveService";
import TodaysLeave from "./TodaysLeave";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
const defaultImage = "/images/placeholder_profile.png";

const LeaveManagerReport = () => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const toster = useContext(TostMsg);
  const [leaveCountType, setleaveCountType] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");

  useEffect(() => {
    GetMasterSystemAlertList("Leave_Ques", 1);
    getLeaveCount();
  }, []);

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage; // Set the fallback image on error
  }, []);

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setMasterSystemAlertData(msg?.Desc);
      }
    });
  }, []);

  async function getLeaveCount() {
    const param = {
      EmpId: userDetails?.EmpId,
      TypeId: 0,
    };
    try {
      const data = await leaveDashboardBalenceCount(param);
      let projectDetailData = await data;
      setleaveCountType(projectDetailData?.Data);
    } catch (err) {
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  return (
    <div className="row sidecarddd">
      <div className="col-xl-12">
        <div className="avgcount-div">
          {leaveCountType?.slice(0, 2).map((count, index) => (
            <div className="avg-counts" key={index}>
              <div className="count-flex-center">
                <div className="h-icon is-info is-rounded">
                 <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                </div>
                <div className="flex-meta">
                  <span>{count?.LeaveBalance.toFixed(1)}</span>
                  <span>{count?.LeaveType}</span>
                </div>
              </div>
              <div className="info-tooltip-area2">
                <img src="/images/org-img/leave/info.svg" className="info" />
                <div className="info-tooltip-content info-area">
                  <div className="purchase-tooltip-content">
                    {count?.Comment}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="col-xl-12">
        <div className="">
          <div className="card-body contact-mandiv">
            {masterSystemAlertData.length === 0 && !userDetails?.OverseerGuid && (
              <div className="reporting-manager">
                <h6 className="no-data">No Data Found.</h6>

                {/* <Link to={`Profile/${userDetails?.OverseerGuid}`}> */}
                  <div>
                    <img
                    src={userDetails?.OverseerImage || defaultImage}
                    onError={handleImageError}
                  />
                  <strong>{userDetails?.OverseerName}</strong>
                  </div>
                {/* </Link> */}
              </div>
            ) }
            {masterSystemAlertData.length > 0 && userDetails?.OverseerGuid && (
              <Link to={`Profile/${userDetails?.OverseerGuid}`}>
                <div className="reporting-manager">
                  <h6>{masterSystemAlertData}</h6>

                  <div>
                     <img
                    src={userDetails?.OverseerImage || defaultImage}
                    onError={handleImageError}
                  />
                  <strong>{userDetails?.OverseerName}</strong>
                  </div>
                </div>
              </Link>
            )}

             {masterSystemAlertData.length > 0 && !userDetails?.OverseerGuid && (
              
                <div className="reporting-manager">
                  <h6>{masterSystemAlertData}</h6>

                  <div>
                      <img
                    src={userDetails?.OverseerImage || defaultImage}
                    onError={handleImageError}
                  />
                  </div>
                  <strong>{userDetails?.OverseerName}</strong>
                </div>
              
            )}
          </div>
        </div>
      </div>
      <TodaysLeave />
      <div className="col-xl-12 position-relation">
        <div
          className="leave-ad-design"
          data-background="assets/img/illustrations/cards/birthday-bg.svg"
        >
          <div className="card-body">
            <div>
              <div className="birthday-avatar text-center">
                <svg viewBox="0 0 160 90" fill="none" xmlns="http://www.w3.org/2000/svg" width="160" height="90">
  <rect x="20" y="40" width="30" height="44" rx="4" fill="#671cc9" opacity=".85"></rect>
  <rect x="22" y="42" width="26" height="2" rx="1" fill="#fff" opacity=".4"></rect>
  <rect x="22" y="47" width="20" height="2" rx="1" fill="#fff" opacity=".3"></rect>

  <rect x="52" y="30" width="30" height="54" rx="4" fill="#ec4119" opacity=".85"></rect>
  <rect x="54" y="32" width="26" height="2" rx="1" fill="#fff" opacity=".4"></rect>
  <rect x="54" y="37" width="18" height="2" rx="1" fill="#fff" opacity=".3"></rect>

  <rect x="84" y="20" width="30" height="64" rx="4" fill="#26a69a" opacity=".85"></rect>
  <rect x="86" y="22" width="26" height="2" rx="1" fill="#fff" opacity=".4"></rect>
  <rect x="86" y="27" width="22" height="2" rx="1" fill="#fff" opacity=".3"></rect>

  <circle cx="132" cy="42" r="12" fill="#f7c5a8"></circle>
  <path d="M126 38 Q128 32 132 32 Q136 32 138 38" fill="#2d1a0e"></path>
  <circle cx="129" cy="42" r="1.5" fill="#2d1a0e"></circle>
  <circle cx="135" cy="42" r="1.5" fill="#2d1a0e"></circle>
  <path d="M129 47 Q132 50 135 47" stroke="#2d1a0e" stroke-width="1" stroke-linecap="round" fill="none"></path>

  <rect x="122" y="54" width="20" height="24" rx="8" fill="#671cc9"></rect>
  <path d="M122 78 Q114 82 108 78" stroke="#f7c5a8" stroke-width="6" stroke-linecap="round"></path>
  <path d="M142 78 Q150 82 152 76" stroke="#f7c5a8" stroke-width="6" stroke-linecap="round"></path>

  <rect x="108" y="62" width="18" height="13" rx="3" fill="#ec4119" opacity=".9"></rect>
  <rect x="110" y="64" width="14" height="1.5" rx=".75" fill="#fff" opacity=".6"></rect>
  <rect x="110" y="68" width="10" height="1.5" rx=".75" fill="#fff" opacity=".4"></rect>

  <text x="96" y="18" font-size="10" fill="#ec4119" opacity=".8">✦</text>
  <text x="148" y="28" font-size="8" fill="#671cc9" opacity=".7">✦</text>
  <text x="12" y="36" font-size="7" fill="#26a69a" opacity=".7">✦</text>
</svg>
              </div>
              <div className="birthday-content">
                {/* {reviewLeavePolicyLink} */}
                <Link to="/Policylist">
                  <h4>Review our employee leave policy</h4>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveManagerReport;
